var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1523 28.064H16.2406C15.0083 28.064 14 27.0557 14 25.8148V16.2492C14 15.0083 15.0083 14 16.2406 14H22.1523C23.3932 14 24.4015 15.0083 24.4015 16.2492V18.3778C24.4015 18.5415 24.2722 18.6621 24.1171 18.6621H23.0658C22.9106 18.6621 22.7814 18.5415 22.7814 18.3778V16.2492C22.7814 15.9045 22.5056 15.6201 22.1523 15.6201H16.2406C15.8959 15.6201 15.6115 15.9045 15.6115 16.2492V25.8148C15.6115 26.1595 15.8959 26.4439 16.2406 26.4439H22.1523C22.5056 26.4439 22.7814 26.1595 22.7814 25.8148V23.6862C22.7814 23.5225 22.9106 23.4019 23.0658 23.4019H24.1171C24.2722 23.4019 24.4015 23.5225 24.4015 23.6862V25.8148C24.4015 27.0557 23.3932 28.064 22.1523 28.064ZM26.6335 23.1002C26.5645 23.1002 26.487 23.0744 26.4266 23.0227L25.6941 22.2816C25.5821 22.1695 25.5821 21.9972 25.6855 21.8851H19.6532C19.4981 21.8851 19.3688 21.7559 19.3688 21.5921V20.5494C19.3688 20.3943 19.4981 20.265 19.6532 20.265H25.7717L25.6941 20.1875C25.5821 20.0754 25.5821 19.8945 25.6941 19.7824L26.4266 19.0413C26.487 18.9896 26.5559 18.9638 26.6335 18.9638C26.711 18.9638 26.78 18.9896 26.8403 19.0413L28.6241 20.8252C28.6759 20.8855 28.7017 20.9544 28.7017 21.032C28.7017 21.1096 28.6759 21.1785 28.6241 21.2388L28.1329 21.7214C28.1071 21.7817 28.0554 21.8248 28.0037 21.8507L26.8403 23.0227C26.78 23.0744 26.711 23.1002 26.6335 23.1002Z",
    fill: "#033476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon13.0387c84c0dff7c7487a058cf45decd8e.svg";
export { ForwardRef as ReactComponent };